








import { defineComponent, PropType, computed, reactive } from '@vue/composition-api';
/**
 * Logo component which can provide different versions of logos - olb or wuw
 */
export default defineComponent({
	props: {
		/**
		 * Source for the default image, representing the logo
		 */
		defaultLogoSrc: {
			type: String,
			default: '',
		},
		defaultLogoAlt: {
			type: String,
			default: '',
		},
		stickyLogoSrc: {
			type: String,
		},
		stickyLogoAlt: {
			type: String,
		},
		mobileLogoSrc: {
			type: String,
		},
		mobileLogoAlt: {
			type: String,
		},
		/**
		 * Link attached to the logo
		 */
		href: String,
		/**
		 * Logo type 'olb' or 'wuw'
		 */
		type: {
			type: String as PropType<'olb' | 'wuw' | 'sticky'>,
		},
	},
	setup(props) {
		const state = reactive({
			src: props.defaultLogoSrc,
			alt: props.defaultLogoAlt,
		});

		window.addEventListener('resize', () => {
			if (props.type !== 'sticky') {
				if (window.innerWidth < 1024 && props.mobileLogoSrc) {
					state.src = props.mobileLogoSrc;
					if (props.mobileLogoAlt) {
						state.alt = props.mobileLogoAlt;
					}
					return;
				}
				state.src = props.defaultLogoSrc;
				state.alt = props.defaultLogoAlt;
			}
		});

		if (window.innerWidth < 1024 && props.mobileLogoSrc) {
			state.src = props.mobileLogoSrc;
			if (props.mobileLogoAlt) {
				state.alt = props.mobileLogoAlt;
			}
		}

		if (props.type === 'sticky' && props.stickyLogoSrc) {
			state.src = props.stickyLogoSrc;
			if (props.stickyLogoAlt) {
				state.alt = props.stickyLogoAlt;
			}
		}

		const classes = computed(() => ['olb-logo', props.type && `olb-logo-${props.type}`]);
		return { classes, state };
	},
});
